import { Theme } from '@mui/material/styles'
export const styles = {
  card: {
    marginTop: (theme: Theme) => theme.spacing(2),
    padding: (theme: Theme) => theme.spacing(2),
  },

  subtitle: { fontSize: '12px' },

  title: {
    fontSize: '18px',
    fontWeight: 'bold',
  },

  subHeader: { fontSize: '16px', fontWeight: '400' },

  longCard: {
    padding: (theme: Theme) => theme.spacing(0.8),
    maxWidth: '1078px',
    height: '100px',
    lineHeight: '21px',
    marginBottom: (theme: Theme) => theme.spacing(2),
  },

  button: {
    marginRight: (theme: Theme) => theme.spacing(3),
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: (theme: Theme) => theme.spacing(1.7),
  },

  container: {
    overflowY: 'auto',
    width: '100%',
    height: '100%',
  },

  infoIcon: {
    marginRight: (theme: Theme) => theme.spacing(0.4),
  },
}
